// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".search-dialog__input[data-v-6de1fa12]{max-width:350px}.dialog__buttons button.report__toggle-btn.v-btn.v-size--default[data-v-6de1fa12]{min-width:100px;height:38px}.dialog__buttons button.report__toggle-btn.v-btn.v-size--default.v-item--active[data-v-6de1fa12]{background-color:#e4d7ff}.dialog__buttons .theme--light.v-btn--active[data-v-6de1fa12]:before{opacity:0}.report__toggle-btn[data-v-6de1fa12]{min-width:100px;height:38px}", ""]);
// Exports
module.exports = exports;
